// @ts-check
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HForm, { TextAreaField } from 'shared/containers/portal_layout/HForm';
import { reduxForm, FieldArray } from 'utils/reduxFormWrapper';
import api from 'utils/api';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import Errors from 'shared/components/Errors';
import FileAttachments from 'shared/components/Referrals/FileAttachments';
import buildFormDataFromNestedJSON from 'utils/buildFormDataFromNestedJSON';
import transformFileLists from 'utils/transformFileLists';
import SpinnerButton from 'shared/components/SpinnerButton';
import LoadingContent from 'shared/components/LoadingContent';

class Edit extends Component {
  constructor(props, context) {
    super(props, context);
    this.updateIncidentalFindings = this.updateIncidentalFindings.bind(this);
    this.state = { incidentalFinding: null };
  }

  componentDidMount() {
    api
      .get(`${this.props.apiEndpoint}/referrals/${this.props.referralId}/incidental_finding/edit`)
      .then(response => {
        this.setState({ incidentalFinding: response.data });
      });
  }

  updateIncidentalFindings(formValues) {
    // FIXME: This assumes we have a browser with FormData, which means IE10+

    // Handle FileList conversion for multiple-file file inputs
    const allFormValues = {
      ...formValues,
      fileAttachmentsAttributes: transformFileLists(formValues.fileAttachmentsAttributes),
    };

    const formData = buildFormDataFromNestedJSON(allFormValues, 'incidental_finding');

    return api
      .put(
        `${this.props.apiEndpoint}/referrals/${this.props.referralId}/incidental_finding`,
        formData
      )
      .then(response => {
        this.props.handleSuccess();
        FlashMessageActions.flashSuccess({
          message: 'You have successfully updated the report for this referral',
        });
        return null;
      });
  }

  render() {
    if (!this.state.incidentalFinding) return <LoadingContent />;
    return (
      <FormifiedPresentationComponent
        form="updateIncidentalFindings"
        onSubmit={this.updateIncidentalFindings}
        initialValues={{
          ...this.state.incidentalFinding,
          fileAttachmentsAttributes: [{}],
        }}
      />
    );
  }
}

const PresentationComponent = props => (
  <HForm onSubmit={props.handleSubmit}>
    <div className="modal-header">
      <h3>Update Incidental Findings Report</h3>
    </div>
    <div className="modal-body">
      <Errors errors={props.error || []} />
      <TextAreaField name="memo" label="Memo" className="input-xxlarge" rows={4} />
      <div className="control-group new-booking-form-group">
        <label className="control-label">Attach More File(s)</label>
        <div className="controls">
          <FieldArray name="fileAttachmentsAttributes" component={FileAttachments} />
        </div>
      </div>
    </div>
    <div className="modal-footer">
      <SpinnerButton type="submit" className="btn btn-primary" loading={props.submitting}>
        Update Report
      </SpinnerButton>
    </div>
  </HForm>
);

PresentationComponent.displayName = 'PresentationComponent';

const FormifiedPresentationComponent = reduxForm({})(PresentationComponent);

Edit.propTypes = {
  apiEndpoint: PropTypes.string.isRequired,
  referralId: PropTypes.string.isRequired,
  handleSuccess: PropTypes.func.isRequired,
};

export default Edit;
